module.exports = __webpack_public_path__ + "img/onlineteacher2.8d5bc3b6.png";